// @ts-check
// Estimativas de envio do modal de ativação (spec 2.0.0, fluxos.md seções 20.10 e 20.11; contrato 09 de fluxos,
// seção 17): quanto tempo os e-mails e os WhatsApps do primeiro trecho levam para sair quando muitos leads entram de
// uma vez. E-mail: leads x e-mails do primeiro trecho, no ritmo de envio da escola (40 por minuto por padrão).
// WhatsApp: pela parte do limite diário do número que cabe aos fluxos. O texto sempre diz "por volta de".
import { PORTFOLIO_SHARES, estimateSendingDays, portfolioCap } from '../../../shared/whatsapp/messaging-limits.js';

export const DEFAULT_EMAIL_DISPATCH_PER_MINUTE = 40;

/**
 * Minutos para os e-mails do primeiro trecho saírem.
 * @param {{ leads: number, emailsPerLead: number, perMinute?: number | null }} input
 */
export function estimateEmailMinutes({ leads, emailsPerLead, perMinute }) {
  const total = Math.max(0, Math.trunc(leads)) * Math.max(0, Math.trunc(emailsPerLead));
  if (total === 0) return 0;
  const rate = perMinute && perMinute > 0 ? perMinute : DEFAULT_EMAIL_DISPATCH_PER_MINUTE;
  return Math.ceil(total / rate);
}

/**
 * Dias para os WhatsApps do primeiro trecho saírem, com a parte dos fluxos no limite diário do número (80%).
 * @param {{ leads: number, messagesPerLead: number, dailyLimit: number | null, usedToday?: number }} input
 * @returns {number | null} null sem limite conhecido (ou ilimitado)
 */
export function estimateWhatsappDays({ leads, messagesPerLead, dailyLimit, usedToday = 0 }) {
  const total = Math.max(0, Math.trunc(leads)) * Math.max(0, Math.trunc(messagesPerLead));
  if (total === 0) return 0;
  if (!dailyLimit) return null;
  const cap = portfolioCap({ limit: dailyLimit, share: PORTFOLIO_SHARES.FLOW });
  if (!cap) return null;
  return estimateSendingDays({ toSendOutsideWindow: total, cap, used: usedToday });
}

/**
 * Duração em texto, sempre aproximada: minutos até 1 hora, horas até 2 dias, depois dias.
 * @param {number} minutes
 * @returns {{ key: string, count: number }} chave em `flows.estimates.*` com a contagem
 */
export function describeEstimatedMinutes(minutes) {
  if (minutes <= 60) return { key: 'flows.estimates.minutes', count: Math.max(1, Math.round(minutes)) };
  if (minutes <= 48 * 60) return { key: 'flows.estimates.hours', count: Math.max(1, Math.round(minutes / 60)) };
  return { key: 'flows.estimates.days', count: Math.max(1, Math.round(minutes / 1440)) };
}

/** @param {number} days @returns {{ key: string, count: number }} */
export const describeEstimatedDays = (days) => ({ key: 'flows.estimates.days', count: Math.max(1, Math.round(days)) });
